import React from 'react'
import UserFeedBackTable from '../../components/user-feedback-table/UserFeedBackTable'

function UserFeedback() {
  return (
    <UserFeedBackTable />
  )
}

export default UserFeedback